// import { get, post } from "../util/winterGameConfig";
// import md5 from "js-md5";
import { get, post } from "../util/winterGameConfig";
import md5 from "js-md5";

// 道具箱-学员信息列表查询接口
export const getStudentInfoList = (params) => {
    let date = parseInt(Date.now() / 1000);
    params.time = date;
    params.sign = md5("eWnIx3SCTRopyYi2" + date);
    return post("/api/applet/cup2023v1/getStudentInfoList", params);
};
// 奖励发放记录-查询道具发放记录列表
export const getPropGrantRecordList = (params) => {
    let date = parseInt(Date.now() / 1000);
    params.time = date;
    params.sign = md5("eWnIx3SCTRopyYi2" + date);
    return post("/api/applet/cup2023v1/getPropGrantRecordList", params);
};
// 奖励发放-获取奖励余额
export const getPropList = (params) => {
    let date = parseInt(Date.now() / 1000);
    params.time = date;
    params.sign = md5("eWnIx3SCTRopyYi2" + date);
    return post("/api/applet/cup2023v1/getPropList", params);
};
// 学员信息详情查询接口
export const getStudentInfo = (params) => {
    let date = parseInt(Date.now() / 1000);
    params.time = date;
    params.sign = md5("eWnIx3SCTRopyYi2" + date);
    return post("/api/applet/cup2023v1/getStudentInfo", params);
};
// 学员信息详情查询接口
export const entertainmenttime = (params) => {
    let date = parseInt(Date.now() / 1000);
    params.time = date;
    params.sign = md5("eWnIx3SCTRopyYi2" + date);
    return post("/api/applet/cup2023v1/entertainmenttime", params);
};
//  学员信息详情-历史周报列表查询接口
export const entertainmenttimehistory = (params) => {
    let date = parseInt(Date.now() / 1000);
    params.time = date;
    params.sign = md5("eWnIx3SCTRopyYi2" + date);
    return post("/api/applet/cup2023v1/entertainmenttimehistory", params);
};
//  加时卡列表查询接口
export const timecardlist = (params) => {
    let date = parseInt(Date.now() / 1000);
    params.time = date;
    params.sign = md5("eWnIx3SCTRopyYi2" + date);
    return post("/api/applet/cup2023v1/timecardlist", params);
};
//  加时卡发放接口
export const rewardentertainmenttimecard = (params) => {
    let date = parseInt(Date.now() / 1000);
    params.time = date;
    params.sign = md5("eWnIx3SCTRopyYi2" + date);
    return post("/api/applet/cup2023v1/createnotify", params);
};
// 加时卡发放历史记录接口
export const entertainmenttimecardlog = (params) => {
    let date = parseInt(Date.now() / 1000);
    params.time = date;
    params.sign = md5("eWnIx3SCTRopyYi2" + date);
    return post("/api/applet/cup2023v1/entertainmenttimecardlog", params);
};
// 管控-娱乐开关查询
export const queryentertainmentswitch = (params) => {
    let date = parseInt(Date.now() / 1000);
    params.time = date;
    params.sign = md5("eWnIx3SCTRopyYi2" + date);
    return post("/api/applet/cup2023v1/queryentertainmentswitch", params);
};
// 管控-娱乐开关开启/关闭
export const entertainmentswitch = (params) => {
    let date = parseInt(Date.now() / 1000);
    params.time = date;
    params.sign = md5("eWnIx3SCTRopyYi2" + date);
    return post("/api/applet/cup2023v1/entertainmentswitch", params);
};
// 管控-娱乐开关管控记录
export const entertainmentswitchlog = (params) => {
    let date = parseInt(Date.now() / 1000);
    params.time = date;
    params.sign = md5("eWnIx3SCTRopyYi2" + date);
    return post("/api/applet/cup2023v1/entertainmentswitchlog", params);
};
// 管控-娱乐开关管控记录
export const friends = (params) => {
    let date = parseInt(Date.now() / 1000);
    params.time = date;
    params.sign = md5("eWnIx3SCTRopyYi2" + date);
    return post("/api/applet/cup2023v1/friends", params);
};
// 管控-好友详情查询
export const frienddetail = (params) => {
    let date = parseInt(Date.now() / 1000);
    params.time = date;
    params.sign = md5("eWnIx3SCTRopyYi2" + date);
    return post("/api/applet/cup2023v1/frienddetail", params);
};

//  复活弹窗、复活待处理列表查询功能
export const revivependingprocessing = (params) => {
    let date = parseInt(Date.now() / 1000);
    params.time = date;
    params.sign = md5("eWnIx3SCTRopyYi2" + date);
    return post("/api/applet/cup2023v1/revivependingprocessing", params);
};
//   复活-复活历史记录
export const revivehistoryrecord = (params) => {
    let date = parseInt(Date.now() / 1000);
    params.time = date;
    params.sign = md5("eWnIx3SCTRopyYi2" + date);
    return post("/api/applet/cup2023v1/revivehistoryrecord", params);
};
// 复活-复活（批量复活）功能接口
export const reviveuser = (params) => {
    let date = parseInt(Date.now() / 1000);
    params.time = date;
    params.sign = md5("eWnIx3SCTRopyYi2" + date);
    return post("/api/applet/cup2023v1/reviveuser", params);
};
// 松鼠杯日报
export const dailypkreport = (params) => {
    let date = parseInt(Date.now() / 1000);
    params.time = date;
    params.sign = md5("eWnIx3SCTRopyYi2" + date);
    return post("/api/applet/cup2023v1/dailypkreport", params);
};
// 松鼠杯日报（56）
export const everydayserviceuserstatistics = (params) => {
    let date = parseInt(Date.now() / 1000);
    params.time = date;
    params.sign = md5("eWnIx3SCTRopyYi2" + date);
    return post("api/applet/cup2023v1/everydayserviceuserstatistics", params);
};
// 灰度查询接口
export const getGrayscaleByCampusId = (params) => {
    let date = parseInt(Date.now() / 1000);
    params.time = date;
    params.sign = md5("eWnIx3SCTRopyYi2" + date);
    return post("/api/applet/cup2023v1/getGrayscaleByCampusId" , params);
};